export default __webpack_public_path__ + "static/media/medics.38fe5fad.png";